export const ENTITY_ACTION_TYPES = {
  Delete: 'Delete',
  Add: 'Add',
  Update: 'Update',
};
